import * as Yup from 'yup'

export const medicamentoSchema = Yup.object().shape({
  medicamento: Yup.string().trim().required('É necessário o nome do medicamento'),
  concentracao: Yup.string().trim().notRequired(),
  apresentacao: Yup.string().trim().notRequired(),
  receituario: Yup.object().nullable().required('Informe o receituário que o medicamento exige'),
})
